<p-toast></p-toast>

<div class="h-full center-container">

    <!-- Show loading while checking LPR status -->
    <div *ngIf="isCheckingLPRStatus" class="flex align-items-center justify-content-center p-5">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <!-- Show message if LPR is not active -->
    <div *ngIf="!isCheckingLPRStatus && !isLPRActive" class="surface-section px-4 py-5 md:px-6 lg:px-8 text-center">
        <div class="mb-3">
            <i class="pi pi-info-circle text-6xl text-orange-500"></i>
        </div>
        <div class="text-900 text-2xl font-bold mb-3">LPR Billing is not active on the portal</div>
        <div class="text-700 text-lg mb-5">
            Please use the old attendant portal to view tenants for this location.
        </div>
        <a [href]="siteUrl" class="p-button p-component">
            <span class="p-button-label">Go to Old Portal</span>
        </a>
    </div>

    <div class="grid" *ngIf="!isCheckingLPRStatus && isLPRActive">
        <div class="card">
            <p-toolbar>
                <div class="p-toolbar-group-center">
                    <h3 class="m-0">New Tenant</h3>
                </div>
            </p-toolbar>
            <div class="col-12">
                <div *ngIf="!tenantDataLoading; else spinner">
                    <form [formGroup]="tenantForm" autocomplete="off">
                        <div class="grid p-fluid mt-5">
                            <div class="field col-6 flex-column sm:col-3">
                                <label for="suite" class="label-required w-full">Suite</label>
                                <input pInputText id="suite" formControlName="suite" />
                                <div *ngIf="formSubmitted && tenantForm.controls['suite'].errors">
                                    <div class="ui-messages-error"
                                        *ngIf="tenantForm.controls['suite'].errors?.['required']">Please
                                        enter suite.
                                    </div>
                                </div>
                            </div>

                            <div class="field col-6 flex-column sm:col-3">
                                <label for="account" class="label-required w-full">Account Number</label>
                                <input pInputText id="account" formControlName="account" />
                            </div>

                            <div class="field col-6 flex-column sm:col-3">
                                <label for="account">Non-Tax Code</label>
                                <input pInputText type="text" id="tax_code" formControlName="tax_code" />
                            </div>

                            <p-fieldset legend="Bill To Address" [toggleable]="false" class="field col-12">
                                <div class="grid">
                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="name" class="label-required w-full">Tenant Name</label>
                                        <input pInputText type="text" id="name" formControlName="name" />
                                        <div *ngIf="formSubmitted && tenantForm.controls['name'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="tenantForm.controls['name'].errors?.['required']">Please
                                                enter tenant name.
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="field col-6 justify-content-center  md:col-3"
                                        *ngIf="locationSettings?.wpsActive">
                                        <span class="flex align-items-center gap-1">
                                            <p-checkbox formControlName="new_company" [binary]="true"
                                                inputId="new_company"></p-checkbox>
                                            <label for="new_company">Create New SUREPARK Company</label>
                                        </span>
                                    </div> -->

                                    <div class="field col-6 flex-column md:col-3" *ngIf="locationSettings?.wpsActive">
                                        <label for="wps_company">Company Name (Group Name)</label>
                                        <p-dropdown formControlName="wps_company" [options]="sureparkGroupList"
                                            optionLabel="name" optionValue="id" placeholder="Select Company Name"
                                            class="w-full" id="wps_company" appendTo="body" [filter]="true"
                                            filterBy="name" aria-describedby="wps_company-help">
                                            <ng-template let-item pTemplate="item">
                                                <div class="flex align-items-center justify-content-between">
                                                    <span>{{ item.name }}</span>
                                                    <span *ngIf="item.id === ''" class="text-green-500 text-sm ml-2">(New)</span>
                                                    <span *ngIf="item.isAssigned"
                                                        class="text-red-500 text-sm ml-2">(Assigned to {{
                                                        item.assignedTo
                                                        }})</span>
                                                </div>
                                            </ng-template>
                                            <ng-template let-item pTemplate="selectedItem">
                                                <div class="flex align-items-center justify-content-between">
                                                    <span>{{ item.name }}</span>
                                                    <span *ngIf="item.id === ''" class="text-green-500 text-sm ml-2">(New)</span>      
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>
                                    <div class="field col-6 md:col-3 flex-column" *ngIf="locationSettings?.wpsActive && locationSettings?.parkingDevice == 'surepark'">
                                        <label for="create_company">&nbsp;</label>
                                        <p-button [disabled]="tenantCreating" [severity]="tenantForm.value['new_company'] ? 'success' : 'primary'" label="{{ tenantForm.value['new_company'] ? 'Edit New Group Details' : 'Create Group' }}" (click)="displayNewGroupDialog()"></p-button>
                                    </div>
                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="email">Billing Email Address</label>
                                        <input pInputText type="text" id="email" formControlName="email" />
                                        <div *ngIf="formSubmitted && tenantForm.controls['email'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="tenantForm.controls['email'].errors?.['invalidEmails']">
                                                One or more email addresses are invalid.
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="field col-6 md:col-3">
                      <label for="billto">Bill To</label>
                        <input pInputText type="text" id="billto" formControlName="billto" />
                    </div> -->

                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="address1" class="label-required w-full">Street Address Line
                                            1</label>
                                        <input pInputText type="text" id="address1" formControlName="address1" />
                                        <div *ngIf="formSubmitted && tenantForm.controls['address1'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="tenantForm.controls['address1'].errors?.['required']">Please
                                                enter bill to address.
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="address2">Street Address Line 2</label>
                                        <input pInputText type="text" id="address2" formControlName="address2" />
                                    </div>

                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="city" class="label-required w-full">City</label>
                                        <input pInputText type="text" id="city" formControlName="city" />
                                        <div *ngIf="formSubmitted && tenantForm.controls['city'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="tenantForm.controls['city'].errors?.['required']">Please
                                                enter city.
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="state" class="w-full">State</label>
                                        <p-dropdown formControlName="state" [options]="states" optionLabel="name"
                                            optionValue="code" placeholder="Select a State" class="w-full" id="state"
                                            appendTo="body" [filter]="true" filterBy="name" [showClear]="true" />
                                    </div>

                                    <div class="field col-6 flex-column md:col-3">
                                        <label for="suite" class="label-required w-full">Zip Code</label>
                                        <input pInputText type="text" id="zip" formControlName="zip" />
                                        <div *ngIf="formSubmitted && tenantForm.controls['zip'].errors">
                                            <div class="ui-messages-error"
                                                *ngIf="tenantForm.controls['zip'].errors?.['required']">Please
                                                enter zip.
                                            </div>
                                            <div class="ui-messages-error"
                                                *ngIf="!tenantForm.controls['zip'].errors?.['required'] && tenantForm.controls['zip'].errors?.['pattern']">
                                                Please
                                                enter valid zip.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </p-fieldset>

                            <p-fieldset legend="Account Preferences" [toggleable]="false" class="col-12"
                                styleClass="field col-12">
                                <div class="grid">
                                    <div class="field flex-column col-6 md:col-3">
                                        <label for="invoice_delivery" class="label-required w-full">Invoice
                                            Delivery</label>
                                        <p-dropdown formControlName="invoice_delivery" [options]="invoiceBatchOptions"
                                            optionLabel="name" optionValue="code" placeholder="Select Invoice Delivery"
                                            styleClass="w-full" id="invoice_delivery" appendTo="body" />
                                    </div>
                                </div>
                            </p-fieldset>


                            <div class="col-12">
                                <div class="grid">
                                    <div class="col-12 flex align-content-center justify-content-end">
                                        <p-button [loading]="tenantCreating" class="col-offset-6 mt-2"
                                            label="Create Tenant" (click)="saveTenantData()"></p-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <p-dialog [(visible)]="showNewGroupDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
                        header="Create SUREPARK Group" [style]="{width: '50vw'}" [dismissableMask]="true">
                        
                        <app-new-surepark-group-form [lotIdOptions]="lotIdOptions" [timezoneGroupOptions]="timezoneGroupOptions"></app-new-surepark-group-form>

                        <ng-template pTemplate="footer">
                            <p-button label="Cancel" severity="danger" (click)="closeNewGroupDialog()">
                            </p-button>
                            <p-button label="Clear" severity="warning" (click)="clearNewGroupDetails()">
                            </p-button>
                            <p-button label="Save Group" (click)="saveNewGroupDetails()">
                            </p-button>
                        </ng-template>
                    </p-dialog>
                </div>

            </div>
        </div>
        <ng-template #spinner>
            <p-progressSpinner></p-progressSpinner>
        </ng-template>
    </div>
</div>